import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger();
@Component({
  selector: 'app-handle-call-waiter',
  templateUrl: './handle-call-waiter.component.html',
  styleUrls: ['./handle-call-waiter.component.scss'],
})
export class HandleCallWaiterComponent implements OnInit {
  @Input() source = 'from-nav';
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    log.debug('source: ', this.source);
  }

  collectTableNumber(e: string) {
    if (e && e !== 'closed modal') {
      this.activeModal.close(e);
    }
  }
}
